<div mat-dialog-title class="flex">
  <h2>Invite Users</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content class="py-1">
  <!-- Form -->
  <form [formGroup]="form" (submit)="form.valid && sendInvitations(f)" #f="ngForm" novalidate>
    <!-- Link -->
    <div class="input-group mb-3">
      <input type="text" class="form-control text-small" placeholder="Generating link..."
        selectOnFocus [ngModel]="link" [ngModelOptions]="{ standalone: true }" readonly>
      <button class="custom btn btn-secondary" type="button" (click)="copyLink()">Copy</button>
    </div>

    <!-- Feedback -->
    <p *ngIf="success" class="text-success">{{success}}</p>
    <p *ngIf="error" class="text-danger">{{error}}</p>

    <!-- Recipients List -->
    <div class="input-group">
      <textarea class="form-control recipients" rows="6" placeholder="Enter space-separated email addresses..." formControlName="recipients"
        [ngClass]="{ 'is-invalid': f.submitted && recipients.invalid }" required>
      </textarea>

      <!-- Invalid -->
      <div *ngIf="f.submitted && recipients.invalid" class="invalid-feedback">
          <div class="mb-1" *ngIf="recipients.errors!.required">Recipients are required</div>
      </div>
    </div>

    <!-- Buttons -->
    <mat-dialog-actions>
      <button type="button" mat-button class="mat-raised-button" (click)="close()">Close</button>
      <button type="submit" mat-button class="mat-raised-button ml-1" color="primary" [disabled]="sending === true">Send Invitations</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
